import { ViewModel } from "binder";
import { PropertyTypeLoader } from "../../dataModelParser";
import { DataModelBuilderViewModel, DataModelClass, Method, methodParameters, Property } from "../dataModelBuilder-viewModel";

export class DataModelFromJsonDeserializer{

    private classes : DataModelClass[];
    private classesByName : Map<string,DataModelClass>;

    deserialize(parent:DataModelBuilderViewModel,json:any){
        let classes = json.classes;
        this.classes = [];
        this.classesByName = new Map<string,DataModelClass>();
        classes.forEach(cls => {
            let newClass = parent.addNewClass();
            newClass.name = cls.name;
            this.classes.push(newClass);
            this.classesByName.set(cls.name,newClass);
        });
        classes.forEach((cls,i) => {
            let relatedClass = this.classes[i];
            cls.properties.forEach(p=>{
                let property = new Property(relatedClass);
                property.name = p.name;
                property.type = new PropertyTypeLoader().createPropertyType(p,property,x=>this.classesByName.get(x));
                property.shallInitialize = p.initialize;
                property.defaultValue = p.default;
                property.preBody = p.preBody;
                property.postBody = p.postBody;
                property.nullAllowanceBody = p.nullAllowanceBody;
                relatedClass.addNewProperty(property);
            });
            cls.methods.forEach(m=>{
                let method = new Method(relatedClass);
                method.name = m.name;
                method.isAsync = m.isAsync;
                method.arguments.update(...m.arguments.map(p=>{
                    let parameter = new methodParameters(method);
                    parameter.name = p.name;
                    parameter.type = new PropertyTypeLoader().createPropertyType(p.type,method,x=>this.classesByName.get(x));
                    return parameter;
                }));
                method.returnType = new PropertyTypeLoader().createPropertyType(m.returnType,method,x=>this.classesByName.get(x));
                method.body = m.body;
                relatedClass.addNewMethod(method);
            })
        });
        
    }
}